<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    config: Schemas['BrandedProductSlide']
    index: number
}>()

const slideContentBrandedProductEl = ref<HTMLDivElement | null>(null)

const { promotion_name, promotion_id, creative_name, creative_slot } = props.config
const promotionData = promotion_name && promotion_id && creative_name && creative_slot
    ? { promotion_name, promotion_id, creative_name, creative_slot }
    : null

const { selectPromotion, computedPromotionData } = usePromotionObserver(
    slideContentBrandedProductEl,
    promotionData
)

function onElClick(event: MouseEvent) {
    if (computedPromotionData?.value) selectPromotion(computedPromotionData.value, event)
}
</script>

<template>
    <div
        ref="slideContentBrandedProductEl"
        class="group"
    >
        <div class="flex flex-wrap mb-3 aspect-[4/5]">
            <MiscLink
                no-prefetch
                class="block w-full h-full overflow-hidden"
                :to="config.url?.value ?? '#'"
                @click="onElClick($event)"
            >
                <MiscImage
                    v-if="config.media?.path"
                    class="cursor-pointer object-cover w-full h-full group-hover:scale-110 transition-all duration-500"
                    :src="config.media.path"
                    :alt="config.media.translated?.alt ?? config.media.alt"
                    width="462"
                    height="462"
                    sizes="368px sm:420px lg:568px xl:768px 2xl:1024px"
                    lazy-load
                />
            </MiscLink>
        </div>

        <div>
            <MiscLink
                no-prefetch
                class="flex flex-col flex-wrap gap-2"
                :to="config.url?.value ?? '#'"
                @click="onElClick($event)"
            >
                <span class="block truncate w-full text-base uppercase tracking-wide leading-tight text-base-content-subtle brand-page-color-active:text-brand-page-color group-hover:underline">
                    {{ config.title?.value }}
                </span>
                <span class="text-sm font-semibold leading-tight group-hover:underline">
                    {{ config.subtitle?.value }}
                </span>
            </MiscLink>
        </div>
    </div>
</template>
